import { connect } from 'react-redux';
import { compose } from 'recompose';
import withPathParams from '%evp_ticket_frontend/js/react/service/withPathParams';
import { SEATINGS } from '%evp_ticket_frontend/js/react/config/routes';
import { selectEvent, fetchEvent } from '%evp_ticket_frontend/js/redux/currentEvent';
import withTranslations from '%app/js/common/components/translation/withTranslations';
import selectCurrentOrder from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import { fetchCheckoutData, selectCart } from '%evp_ticket_frontend/js/redux/currentCart';
import reserveSeating from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/reserveSeating';
import discardSeating from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/discardSeating';
import setTicketPurchaseDialog from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setTicketPurchaseDialog';
import updateReservation from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/updateReservation';
import { initializeHallDefinition } from '%paysera_seat_selection_integration/js/seatings/redux';
import Page from './Page';

export default compose(
    connect(
        state => ({
            event: selectEvent(state),
            order: selectCurrentOrder(state),
            cart: selectCart(state),
        }),
        dispatch => ({
            fetchEvent: token => dispatch(fetchEvent(token)),
            fetchCheckoutData: () => dispatch(fetchCheckoutData()),
            reserveSeating: (seating, count, sectorId) => dispatch(reserveSeating(seating, count, sectorId)),
            discardSeating: seating => dispatch(discardSeating(seating)),
            handleGeneralAdmissionClick: generalAdmission => dispatch(setTicketPurchaseDialog(generalAdmission)),
            updateReservation: cartItem => dispatch(updateReservation(cartItem)),
            initializeHallDefinition: (data, optimized) => dispatch(initializeHallDefinition(data, optimized)),
        }),
    ),
    withTranslations([
        'TicketFrontendBundle',
        'PayseraSeatSelectionIntegrationBundle',
        'PayseraCartBundle',
        'PayseraAdminBundle',
    ]),
    withPathParams(SEATINGS),
)(Page);
